import { Link } from '@alfa-bank/site-link';
import { Text } from '@alfa-bank/site-text-v2';
import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './styles.css';

// TODO: вынести в контент
/**
 * Текст условий направления формы
 */
export const LegalConditionsContent: FC = () => (
    <>
        <Text className={cn(styles.external, styles.headingContent)} tag="h5">
            Условия направления физическими лицами заявлений в электронном виде в
            информационно-телекоммуникационной сети «Интернет» на сайте АО «АЛЬФА-БАНК» или
            посредством услуги «Альфа-Мобайл» в целях получения услуг АО «АЛЬФА-БАНК»
        </Text>
        <Text view="primary-large">
            Гражданин Российской Федерации <strong>(далее – «Заявитель»)</strong>, направляющий в АО
            «АЛЬФА-БАНК» (Генеральная лицензия Банка России № 1326, адрес места нахождения: 107078,
            г. Москва, ул. Каланчевская, д. 27, Телефонный центр «Альфа-Консультант»:
            +7(495)788-88-78 для звонков из Москвы и Московской области, 8-800-200-0000 для звонков
            с мобильных телефонов и стационарных телефонов, зарегистрированных в регионах){' '}
            <strong>(далее – «Банк»)</strong> заявление в электронном виде на сайте Банка или
            посредством услуги «Альфа-Мобайл» <strong>(далее – «Заявление»)</strong> в целях
            получения услуги Банка, тем самым понимает, принимает и подтверждает следующее:
        </Text>
        <ol>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель подтверждает, что все указанные в Заявлении персональные данные
                    принадлежат лично Заявителю.
                </Text>
            </li>
            <li>
                <Text view="primary-large">
                    Заявитель подтверждает, что он является совершеннолетним гражданином Российской
                    Федерации, имеет законное право на предоставление Банку данных, указанных в
                    Заявлении, и такие данные являются полными и действительными на момент их
                    предоставления Банку.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель подтверждает, что не имеет бенефициарных владельцев<sup>1</sup> и
                    выгодоприобретателей<sup>2</sup>, действует по собственной доброй воле в личных
                    законных целях и интересах.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель подтверждает, что не является публичным должностным лицом (российским,
                    иностранным, должностным лицом публичной международной организации) или его
                    ближайшим окружением.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель подтверждает отсутствие сведений, негативно влияющих на деловую
                    репутацию Заявителя.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель подтверждает хорошее финансовое положение.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель обязуется{' '}
                    <span style={{ textDecoration: 'underline' }}>не совершать</span> следующие
                    действия:
                </Text>
                <ul>
                    <li>
                        <Text
                            className={cn(styles.external, styles.paragraph)}
                            view="primary-large"
                        >
                            Любым способом посредством сайта{' '}
                            <Link href="/" target="_blank">
                                https://alfabank.ru/
                            </Link>{' '}
                            или иных ресурсов Банка размещать, распространять, сохранять, загружать
                            и/или уничтожать материалы (информацию) в нарушение законодательства
                            Российской Федерации;
                        </Text>
                    </li>
                    <li>
                        <Text
                            className={cn(styles.external, styles.paragraph)}
                            view="primary-large"
                        >
                            Размещать заведомо недостоверную информацию, регистрироваться, используя
                            чужие персональные данные (персональные данные третьих лиц, а также
                            вымышленных лиц);
                        </Text>
                    </li>
                    <li>
                        <Text
                            className={cn(styles.external, styles.paragraph)}
                            view="primary-large"
                        >
                            Размещать заведомо недостоверную информацию об адресе регистрации/адресе
                            фактического проживания, номере(-ах) телефона(-ов), размещать информацию
                            об адресах электронной почты, права на использование которых отсутствуют
                            у Заявителя.
                        </Text>
                    </li>
                </ul>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель обязуется не нарушать информационную безопасность электронных ресурсов
                    Банка, не нарушать процедуры регистрации, предусмотренные Банком.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Банк прилагает все возможные усилия и предусмотренные законодательством
                    Российской Федерации меры для того, чтобы избежать несанкционированного
                    использования персональной информации Заявителя. Заявитель уведомлен и
                    соглашается с тем, что Банк не несет ответственности за возможное нецелевое
                    использование персональной информации пользователей, произошедшее из-за
                    технических неполадок в программном обеспечении, серверах, компьютерных сетях,
                    находящихся вне контроля Банка, или в результате противоправных действий третьих
                    лиц.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель выражает согласие и уполномочивает Банк получать персональные данные
                    Заявителя в необходимом объеме от Министерства цифрового развития, связи и
                    массовых коммуникаций Российской Федерации (Минцифра России) посредством единой
                    системы идентификации и аутентификации (ЕСИА) в целях рассмотрения возможности
                    оказания Заявителю услуг Банка, заключения с Банком договоров, соглашений.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель выражает согласие и уполномочивает Банк предоставлять полностью или
                    частично персональные данные налоговому органу в целях получения информации об
                    идентификационном номере налогоплательщика Заявителя посредством обращения к
                    ресурсу «Узнай свой ИНН», размещенному на официальном сайте Федеральной
                    налоговой службы в информационно-телекоммуникационной сети «Интернет», а также
                    получать посредством обращения к ресурсу «Узнай свой ИНН» данные об
                    идентификационном номере налогоплательщика Заявителя.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель дает свое согласие на получение Банком из бюро кредитных историй
                    информации об основной части кредитной истории Заявителя в соответствии с
                    Федеральным законом от 30.12.2004 № 218-ФЗ «О кредитных историях» в целях
                    осуществления проверки Банком благонадежности Заявителя и/или для формирования
                    Банком в отношении Заявителя кредитных предложений, принятия Банком решения о
                    предоставлении Заявителю кредита(-ов), заключения с Заявителем и дальнейшего
                    сопровождения (исполнения) договоров. Согласие на получение Банком из бюро
                    кредитных историй информации об основной части кредитной истории Заявителя
                    действует в течение шести месяцев со дня его оформления.
                </Text>
            </li>
            <li>
                <Text className={cn(styles.external, styles.paragraph)} view="primary-large">
                    Заявитель выражает согласие на направление Банком от своего имени запроса в
                    Пенсионный фонд Российской Федерации <strong>(далее – «ПФР»)</strong> через
                    систему межведомственного электронного взаимодействия{' '}
                    <strong>(далее – «СМЭВ»)</strong> на получение информации о состоянии своего
                    индивидуального лицевого счета застрахованного лица и предоставление указанной
                    информации ПФР посредством СМЭВ в Банк для последующей ее обработки Банком
                    (включая запись, накопление, систематизацию, хранение, извлечение,
                    использование, удаление) в целях оценки его платежеспособности для принятия
                    решения о заключении с ним договора потребительского кредита и предоставления
                    кредитов. Настоящее согласие на запрос и получение информации из ПФР действует в
                    течение шести месяцев с даты направления запроса и получения из ПФР Банком
                    информации либо до момента принятия Банком окончательного решения о заключении,
                    либо об отказе в заключении с Заявителем договора потребительского кредита (если
                    такое решение будет принято до истечения шести месяцев).
                </Text>
            </li>
        </ol>
        <Text className={cn(styles.external, styles.paragraph)} view="primary-medium">
            <sup>1</sup> <strong>бенефициарный владелец</strong> – физическое лицо, которое в
            конечном счете прямо или косвенно (через третьих лиц) имеет возможность контролировать
            действия Заявителя, в том числе имеет возможность определять решения, принимаемые
            Заявителем.
        </Text>
        <Text className={cn(styles.external, styles.paragraph)} view="primary-medium">
            <sup>2</sup> <strong>выгодоприобретатель</strong> – лицо, к выгоде которого действует
            Заявитель, в том числе на основании агентского договора, договоров поручения, комиссии и
            доверительного управления, при проведении операций с денежными средствами и иным
            имуществом.
        </Text>
    </>
);
